var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-dialog",
    {
      attrs: { width: "75%" },
      scopedSlots: _vm._u(
        [
          {
            key: "activator",
            fn: function ({ on }) {
              return [_vm._t("clickable", null, { on: on })]
            },
          },
        ],
        null,
        true
      ),
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline grey", attrs: { "primary-title": "" } },
            [
              _vm._v(
                " How to use Heimdall " +
                  _vm._s(_vm.instanceMode) +
                  " " +
                  _vm._s(_vm.version) +
                  " "
              ),
            ]
          ),
          _c(
            "v-card-text",
            [
              _c("br"),
              _c("h2", [
                _vm._v(" View the results of an "),
                _c("a", { attrs: { href: "htps://www.inspec.io" } }, [
                  _vm._v("InSpec"),
                ]),
                _vm._v(
                  " profile execution (using InSpec's JSON reporter) or the results from the "
                ),
                _c("a", { attrs: { href: "https://github.com/mitre/saf" } }, [
                  _vm._v("SAF CLI"),
                ]),
                _vm._v(
                  " which converts scanning results from many other non-InSpec tools to a Heimdall Data Format JSON file. "
                ),
              ]),
              _c("br"),
              _c("p", [
                _vm._v(" Easily see how many controls passed and failed. "),
                _c("br"),
                _c("br"),
                _vm._v(
                  "Click on the donut charts to filter the controls by status and severity. "
                ),
              ]),
              _c("v-img", {
                attrs: { src: require("../../assets/data_cards.png") },
              }),
              _c("br"),
              _c("hr"),
              _c("br"),
              _c("h2", [
                _vm._v(
                  " Use the treemap to navigate through your controls by NIST family classification. "
                ),
              ]),
              _c("br"),
              _c("v-img", {
                attrs: { src: require("../../assets/treemap.png") },
              }),
              _c("br"),
              _c("hr"),
              _c("br"),
              _c("h2", [
                _vm._v(
                  "Use the data table to sort your controls and see more details."
                ),
              ]),
              _c("br"),
              _c("v-img", {
                attrs: { src: require("../../assets/data_table.png") },
              }),
              _c("br"),
              _c("hr"),
              _c("br"),
              _c("h2", [
                _vm._v(
                  " Click on a control to detect which tests passed or failed, or see its details and code. "
                ),
              ]),
              _c("br"),
              _c("v-img", {
                attrs: { src: require("../../assets/control_data.png") },
              }),
              _c("br"),
              _c("hr"),
              _c("br"),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-actions",
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", text: "" },
                  on: {
                    click: function ($event) {
                      _vm.dialog = false
                    },
                  },
                },
                [_vm._v("Close Window")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }